import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgThumbsUp = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "inherit",
		fillRule: "nonzero",
		d: "M.833 17.5h3.334v-10H.833v10zm18.334-9.167c0-.916-.75-1.666-1.667-1.666h-5.258l.791-3.809.025-.266c0-.342-.141-.659-.366-.884l-.884-.875-5.483 5.492A1.63 1.63 0 0 0 5.833 7.5v8.333c0 .917.75 1.667 1.667 1.667H15c.692 0 1.283-.417 1.533-1.017l2.517-5.875c.075-.191.117-.391.117-.608V8.408l-.009-.008.009-.067z"
	})
});
export default SvgThumbsUp;
